import React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { login } from '../../services/auth';

const Login = () => {
  const handleGoogleLogin = () => {
    login();
  };

  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
        }}
      >
        <Typography variant="h4" component="h1" gutterBottom>
          Admin Login
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
          Sign in with your Google account to access the admin panel
        </Typography>
        <Button
          variant="contained"
          size="large"
          onClick={handleGoogleLogin}
          sx={{ minWidth: 200 }}
        >
          Sign in with Google
        </Button>
      </Box>
    </Container>
  );
};

export default Login;




